import gql from "graphql-tag";

export const staffMemberFragment = gql`
  fragment StaffMemberFragment on User {
    id
    email
    firstName
    isActive
    lastName
    contactNo
    dateJoined
    status
    promoCreator
    mfaSetupDate
    mfaStatus
    accessGroup {
      id
      name
      code
      description
      smopUsertypeCode
      accesses {
        objectId
        privateObjectId
        accessType
        description
      }
    }
  }
`;
export const staffMemberDetailsFragment = gql`
  ${staffMemberFragment}
  fragment StaffMemberDetailsFragment on User {
    ...StaffMemberFragment
    permissionGroups {
      id
      name
      userCanManage
    }
    userPermissions {
      code
      name
    }
    avatar(size: 120) {
      url
    }
  }
`;
